import { Component, h } from 'preact';
import AppLayout from './layouts/AppLayout';
import PropTypes from 'prop-types';
import '../firebase';
import UserLogin from './UserLogin';
import UserRegister from './UserRegister';

export default class UserAuth extends Component {
  constructor() {
    super();

    this.state = {
      tab: 'register', // tab = 'register' or 'login'
    };
  }

  render() {
    let content;
    const { tab } = this.state;

    if (tab === 'login') {
      content = <UserLogin />;
    } else {
      content = <UserRegister />;
    }

    return (
      <AppLayout title="User Auth">
        <div key="UserAuth" className="content-padded">
          <div className="segmented-control">
            <a className={'control-item' + (tab === 'register' ? ' active' : '')} onClick={() => this.setState({ tab: 'register' })}>Register</a>
            <a className={'control-item' + (tab === 'login' ? ' active' : '')} onClick={() => this.setState({ tab: 'login' })}>Login</a>
          </div>
          {content}
        </div>
      </AppLayout>
    );
  }
}

UserAuth.propTypes = {
  user: PropTypes.object,
};
